/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.sub-channel[_ngcontent-%COMP%]   channel-content[_ngcontent-%COMP%]{margin-bottom:40px}h2[_ngcontent-%COMP%]{font-weight:300;font-size:2.4rem;margin:0 0 10px;max-width:calc(100% - 90px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}h2[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:inherit}h2[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{vertical-align:middle;margin-left:4px;margin-bottom:4px;color:var(--be-secondary-text)}media-list-item[_ngcontent-%COMP%]{margin-bottom:35px}"];
export { styles as styles };
